import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import content from '../../content';
import './Projects.css';

const { projects } = content;

// Tabs follow whatever categories content.js actually uses, in first-seen order.
const usedCategories = [...new Set(projects.items.map((p) => p.category).filter(Boolean))];
const categories =
  usedCategories.length > 1 ? [projects.allTabLabel, ...usedCategories] : [];

function Projects() {
  const [activeCategory, setActiveCategory] = useState(projects.allTabLabel);

  useEffect(() => {
    AOS.init({ duration: 900, once: true, offset: 80 });
  }, []);

  const filtered =
    activeCategory === projects.allTabLabel
      ? projects.items
      : projects.items.filter((p) => p.category === activeCategory);

  return (
    <section id={projects.id} className="projects-section">
      <div className="projects-container">
        {projects.label && (
          <div className="section-label" data-aos="fade-up">{projects.label}</div>
        )}
        <h2 className="section-heading" data-aos="fade-up" data-aos-delay="50">
          {projects.heading}
        </h2>

        {categories.length > 0 && (
          <div className="projects-tabs" data-aos="fade-up" data-aos-delay="100">
            {categories.map((cat) => (
              <button
                key={cat}
                className={`tab-btn ${activeCategory === cat ? 'active' : ''}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        )}

        <div className="projects-grid">
          {filtered.map((project, i) => (
            <div
              key={project.name}
              className="project-card"
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              {project.category && (
                <span className="project-category-badge">{project.category}</span>
              )}
              <h3 className="project-name">{project.name}</h3>
              <p className="project-description">{project.description}</p>
              {project.tags && project.tags.length > 0 && (
                <div className="project-tags">
                  {project.tags.map((tag) => (
                    <span key={tag} className="project-tag">{tag}</span>
                  ))}
                </div>
              )}
              {project.link && (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link"
                >
                  {project.linkLabel || 'View'}
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
